import { HStack, Icon, Separator, Text } from '@chakra-ui/react';

import { useUpToDateFileAttribute } from '~/core/shared/hooks';
import { useRiskConfig } from './hooks';
import { FraudRiskPillProps } from './types';

export const FraudRiskPill = ({ file, fraudUpdates }: FraudRiskPillProps) => {
  const updatedFileAttribue = useUpToDateFileAttribute(file, fraudUpdates);

  const riskConfig = useRiskConfig(updatedFileAttribue?.fraudRisk);

  return (
    <HStack
      bg={riskConfig.bgColor}
      borderRadius="full"
      gap={2}
      h="26px"
      px={3}
      py={0}
      separator={
        <Separator
          borderColor={riskConfig.dividerColor}
          opacity={1}
          orientation="vertical"
        />
      }
      w="fit-content"
    >
      <HStack gap={2}>
        {riskConfig.icon && (
          <Icon
            as={riskConfig.icon}
            boxSize="20px"
            color={riskConfig.iconColor}
          />
        )}
        <Text
          color={riskConfig.color}
          fontSize="xs"
          fontWeight="semibold"
          textTransform="uppercase"
          whiteSpace="nowrap"
        >
          {riskConfig.displayText}
        </Text>
      </HStack>
      <Text
        color={riskConfig.color}
        flex="none"
        fontSize="xs"
        fontWeight="semibold"
        whiteSpace="nowrap"
      >
        {riskConfig.scoreText}
      </Text>
    </HStack>
  );
};
